module.exports = __webpack_public_path__ + "officialStatic/img/scz.8d28072.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/smartCampus/role/scz.png
// module id = /0LH
// module chunks = 0